<template>
  <StandardCardPageContainer>
    <h1 id="questionnaire-template-view__name" class="text-left mb-10">
      {{ questionnairesStore.selectedQuestionnaire.label }}
    </h1>
    <DisplayQuestionnaire
      :template-label="questionnairesStore.selectedQuestionnaire.templateId"
    />
  </StandardCardPageContainer>
</template>

<script setup lang="ts">
import StandardCardPageContainer from "@/components/containers/StandardCardPageContainer.vue";
import { useQuestionnairesStore } from "@/stores/questionnaires";
import DisplayQuestionnaire from "@/views/template/DisplayQuestionnaire.vue";

const questionnairesStore = useQuestionnairesStore();
</script>
